jQuery(document).ready(function ($) {

	// Add the active class to accordions open on page load.
	$('.accordion-collapse.show').each(function () {
		$(this)
			.closest('.accordion-item')
			.addClass('accordion-item--active');
	});

	// Add the class when an accordion opens.
	$(document).on('show.bs.collapse', '.accordion-collapse', function () {
		$(this)
			.closest('.accordion-item')
			.addClass('accordion-item--active');
	});

	// Remove the class when an accordion closes.
	$(document).on('hide.bs.collapse', '.accordion-collapse', function () {
		$(this)
			.closest('.accordion-item')
			.removeClass('accordion-item--active');
	});

	// Wrap every table with a custom class on all blog posts.
	$('.js-content-before-banner table').each(function() {
		if (!$(this).parent().hasClass('single-post-table-wrap')) {
			$(this).wrap('<div class="single-post-table-wrap"></div>');
		}
	});
});
